import log from "./log";

class gaTrack {
	constructor() {
		this.validateAbd = this.validateAbd.bind(this);

		$("body").on("abd-event", this.validateAbd);
	}

	validateAbd() {
		if (!window.abd) {
			this.run();
		} else {
			log(__filename, "Adblock detected, cant start", "info");
		}
	}

	run() {
		log(__filename, `Binding elements`);
		if (window.section == "homepage") {
			$(".Games-heading")
				.find("a")
				.on("click", { opt_label: "home_ATF" }, this.sendEvent);
			$(".Games-categorylist--four--nocenter")
				.find("a")
				.on("click", { opt_label: "home_BTF" }, this.sendEvent);
		} else if (window.section == "section") {
			$("#js-sections-top-part")
				.find("a")
				.on("click", { opt_label: "categories_ATF" }, this.sendEvent);
			$(".GameScreen-breadcrumb")
				.find("a")
				.on("click", { opt_label: "categories_breadcrumb" }, this.sendEvent);
			$(".js-bottom-categories")
				.find("a")
				.on("click", { opt_label: "categories_BTF" }, this.sendEvent);
		} else if (window.section == "gamescreen") {
			$(".GameScreen-breadcrumb")
				.find("a")
				.on("click", { opt_label: "games_breadcrumb" }, this.sendEvent);
			$(".js-bottom-categories")
				.find("a")
				.on("click", { opt_label: "games_BTF" }, this.sendEvent);
		}
	}

	sendEvent(event) {
		// event.preventDefault();
		const { opt_label } = event.data;
		const category = $(this).attr("href");
		log(__filename, `Sending gaTrack event ${category} : ${opt_label}`);
		if (typeof ga === "function") {
			ga("send", "event", category, "click", opt_label, 0);
		}
	}
}

export default gaTrack;
